import styled from 'styled-components';

export const StyledBlockquote = styled.blockquote`
  border-left: 2px solid ${(p) => p.theme.alias.shadow};
  padding-left: ${(p) => p.theme.space[3]};

  &:not(:first-child) {
    margin-top: ${(p) => p.theme.space[3]};
  }
`;
